import { useTranslation } from "react-i18next";

import { ExercisePrimaryMuscleGroupCombobox } from "src/components/ExercisePrimaryMuscleGroupCombobox";
import { MultiSelectChipsCombobox } from "src/components/MultiSelectChipsCombobox";
import { useExerciseMuscleGroups } from "src/state/exerciseMuscleGroups";
import { type TranslationKey } from "src/types";

export { ExercisePrimaryMuscleGroupCombobox };

export interface ExerciseSecondaryMuscleGroupsComboboxProps {
  onChange: (s: string[]) => void;
  value: string[];
  placeholder: string;
  disabledIds?: string[];
}

export function ExerciseSecondaryMuscleGroupsCombobox(
  props: ExerciseSecondaryMuscleGroupsComboboxProps,
) {
  const exerciseMuscleGroups = useExerciseMuscleGroups();
  const { t } = useTranslation();

  const items = exerciseMuscleGroups.muscleGroupsList.map((mg) => {
    return {
      id: mg.id,
      label: t(`muscleGroups.${mg.name}` as TranslationKey),
    };
  });

  return (
    <MultiSelectChipsCombobox
      items={items}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
      emptyText="No muscles found"
      disabledIds={props.disabledIds}
    />
  );
}

export interface ExercisePrimaryMuscleGroupsComboboxProps {
  onChange: (s: string) => void;
  value: string | null;
  placeholder: string;
}
